import { createSettingsParams } from '@wix/tpa-settings';
// import applicationJson from '../../../.application.json';
import { type AdUnit } from '@wix/ambassador-adsense-v1-adsense-adunit/types';
import { ConnectStatus } from '@wix/ambassador-adsense-v1-adsense-user/types';
import { ADUNIT_SIZE } from '@app/types';

export const TAB = {
  MAIN: 'MAIN',
  AD_UNIT: 'AD_UNIT',
  SUPPORT: 'SUPPORT',
} as const;

export type Tab = (typeof TAB)[keyof typeof TAB];

export type ISettingsParams = {
  tab: Tab;
  selectedAdUnit: AdUnit;
  connectStatus: ConnectStatus;
};

export default createSettingsParams<ISettingsParams>({
  tab: {
    getDefaultValue: () => TAB.MAIN,
  },
  selectedAdUnit: {
    getDefaultValue: () => ({
      contentAdsSettings: {
        size: ADUNIT_SIZE.RESPONSIVE,
      },
    }),
  },
  connectStatus: {
    getDefaultValue: () => ConnectStatus.DISCONNECTED,
  },
});
